<!--
 * @Author: mzw
 * @Date: 2021-09-23 16:25:34
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-04-10 10:46:16
 * @Description: 订单价格组件
-->
<template>
    <div class="order-price">
        <el-col :span="11" style="border:1px solid transparent">
            <el-form-item :label="`${$t('order.remark')}：`" v-if="hasRemark" class="remark-box">
                <el-input type="textarea" :rows="4" :placeholder="$t('order.remarkHolder')" :value="orderRemarks" @input="remarksChange"></el-input>
                <span class="remark-num">{{remarkNum}}/150</span>
            </el-form-item>
        </el-col>
        <el-col :span="6" :offset="7">
            <ul class="price-detail">
                <li><label>{{$t('order.productAmount')}}：</label>{{$t('common.currency')}}{{priceData.payMoney ? priceData.payMoney.toFixed(2) : '0.00'}}</li>
                <li v-if="version === 'tax'">
                  <label>{{$t('order.taxamount')}}：</label>{{$t('common.currency')}}{{priceData.taxAmount ? priceData.taxAmount.toFixed(2) : "0.00"}}
                </li>
                <li><label>{{$t('order.discount')}}：</label>{{$t('common.currency')}}{{priceData.discountAmount ? priceData.discountAmount.toFixed(2) : '0.00'}}</li>
                <li><label>{{$t('order.shipping')}}：</label>{{$t('common.currency')}}{{priceData.expressFee ? priceData.expressFee.toFixed(2) : '0.00'}}</li>
                <li><label>{{$t('order.payAmount')}}：</label><big>{{$t('common.currency')}}{{priceData.totalPay ? priceData.totalPay.toFixed(2) : '0.00'}}</big></li>
            </ul>
        </el-col>
    </div>
</template>
<script>
export default {
  data () {
    return {
      remarkNum: 0 // 备注输入字数
    }
  },
  props: {
    priceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    version: {
      type: String,
      default: ''
    },
    hasRemark: {
      type: Boolean
    },
    orderRemarks: {
      type: String
    }

  },
  methods: {
    remarksChange (val) {
      if (val.length > 150) {
        val.length = 150
      }
      this.remarkNum = val.length
      this.$emit('remarksChange', val)
    }
  }
}
</script>
<style lang='scss' scoped>
    .order-price {
        .remark-box{
            position: relative;
            .remark-num{
                position: absolute;
                bottom: 5px;
                right: 10px;
                font-size: 12px;
                color: #797979;
                line-height: 14px;
            }
        }
        width: 100%;
        height: auto;
        box-sizing: border-box;
        border: 1px solid #ddd;
        padding: 24px;
        overflow: hidden;
        .price-detail {
            text-align: right;
            line-height: 28px;
            overflow: hidden;
            label {
                width: 70px;
                color: #797979;
                float: left;
                width: 105px;
                white-space: nowrap;
            }
            big {
                font-size: 16px;
                color: #D43D3D;
            }
        }
    }
</style>
